import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebcomponentsService {
  private readonly webElement: string;
  private readonly webElementLoadedSubject: BehaviorSubject<boolean>;

  public isLoaded$: Observable<boolean>;

  private readonly cacheBuster: string;

  constructor() {
    this.webElement = 'rapiplazo';
    this.webElementLoadedSubject = new BehaviorSubject<boolean>(false);
    this.isLoaded$ = this.webElementLoadedSubject.asObservable();
    this.cacheBuster = environment.cacheBuster;
  }

  public load(): void {
    this.loadScript();
  }

  private loadScript(): void {
    const scriptPath = `${this.webElement}/main.js`;
    const script = document.createElement('script');
    script.src = `${environment.webElementsUrl}${scriptPath}?v=${this.cacheBuster}`;
    script.onload = () => {
      this.loadCSS();
    };
    script.onerror = (error) => console.error('Error loading JS file:', error);
    document.body.appendChild(script);
  }

  private loadCSS(): void {
    const styleElement = document.createElement('link');
    styleElement.rel = 'stylesheet';
    const stylePath = `${this.webElement}/styles.css`;

    styleElement.href = `${environment.webElementsUrl}${stylePath}?v=${this.cacheBuster}`;
    styleElement.onload = () => {
      this.webElementLoadedSubject.next(true);
    };
    styleElement.onerror = (error) => console.error('Error loading CSS file:', error);
    document.head.appendChild(styleElement);
  }
}
